/* Dashboard Builder — read-only renderer for a saved layout. */
import React from 'react';
import GridLayout, { WidthProvider, Layout } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { DashboardDataProvider } from './DashboardData';
import { TileView } from './tiles';
import { SavedLayout, DEFAULT_COLORS, DashFilters } from './types';

const Grid = WidthProvider(GridLayout);

export const LayoutRenderer: React.FC<{ layout: SavedLayout; filters?: DashFilters }> = ({ layout, filters }) => {
  const colors = { ...DEFAULT_COLORS, ...(layout.colors || {}) };
  const gl: Layout[] = layout.tiles.map((t) => ({ i: t.i, x: t.x, y: t.y, w: t.w, h: t.h, static: true }));
  return (
    <DashboardDataProvider colors={layout.colors} filters={filters}>
      <div data-testid="dashboard-custom-grid">
        <Grid className="layout" layout={gl} cols={12} rowHeight={80} margin={[16, 16]}
              isDraggable={false} isResizable={false} compactType="vertical">
          {layout.tiles.map((t) => (
            <div key={t.i} className="rounded-lg border border-border/60 bg-white flex flex-col overflow-hidden shadow-sm" data-testid={`tile-${t.type}`}>
              <div className="px-3 py-1.5 border-b border-border/50 text-xs font-semibold text-raptor-navy shrink-0 truncate">{t.title}</div>
              <div className="flex-1 min-h-0"><TileView tile={t} colors={colors} /></div>
            </div>
          ))}
        </Grid>
      </div>
    </DashboardDataProvider>
  );
};
